import { render, staticRenderFns } from "./perfil-detalle.vue?vue&type=template&id=021ead30&scoped=true&"
import script from "./perfil-detalle.vue?vue&type=script&lang=ts&"
export * from "./perfil-detalle.vue?vue&type=script&lang=ts&"
import style0 from "./perfil-detalle.vue?vue&type=style&index=0&id=021ead30&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ead30",
  null
  
)

export default component.exports